import { httpClient } from "../utils";

export const shopService = {
    isShopPublic,
    getPublicShop,
    getPublicShopConfig
};

function isShopPublic(shop_id = 0) {
    return httpClient.callApi("GET", `/shop/isShopPublic?shop_id=${shop_id}`, {}, false);
}

function getPublicShop(shop_id = 0) {
    return httpClient.callApi("GET", `/shop/getPublicShop?shop_id=${shop_id}`, {}, false);
}

function getPublicShopConfig(shop_id = 0) {
    return httpClient.callApi("GET", `/shop/getPublicShopConfig?shop_id=${shop_id}`, {}, false);
}